import { Zap, Home, Building2, AlertTriangle, Lightbulb, Plug, ArrowRight } from 'lucide-react';

const services = [
  {
    icon: Home,
    title: 'Residential Electrical',
    description: 'Complete home electrical solutions including wiring, outlets, lighting, and code compliance inspections.',
    span: 'md:col-span-8',
    featured: true,
    image: 'https://images.pexels.com/photos/4792521/pexels-photo-4792521.jpeg',
  },
  {
    icon: AlertTriangle,
    title: 'Emergency Repairs',
    description: 'Power outages, sparking outlets, or tripped breakers? We respond fast.',
    span: 'md:col-span-4',
    featured: false,
  },
  {
    icon: Zap,
    title: 'Panel Upgrades',
    description: 'Modernize your electrical panel for safety and increased capacity.',
    span: 'md:col-span-4',
    featured: false,
  },
  {
    icon: Building2,
    title: 'Commercial Services',
    description: 'Office buildings, retail spaces, and industrial facilities. Minimize downtime with our expert commercial team.',
    span: 'md:col-span-8',
    featured: true,
    image: 'https://images.pexels.com/photos/397998/pexels-photo-397998.jpeg',
  },
  {
    icon: Lightbulb,
    title: 'Lighting Installation',
    description: 'Recessed lighting, chandeliers, outdoor fixtures, and LED upgrades.',
    span: 'md:col-span-6',
    featured: false,
  },
  {
    icon: Plug,
    title: 'Outlet & Switch Work',
    description: 'New installations, GFCI outlets, USB outlets, and smart switches.',
    span: 'md:col-span-6',
    featured: false,
  },
];

export const ServicesBento = () => {
  return (
    <section id="services" className="py-24 bg-zinc-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="mb-16">
          <span className="overline" data-testid="services-overline">What We Do</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mt-3 tracking-tight" data-testid="services-heading">
            Our Electrical Services
          </h2>
          <p className="text-zinc-400 mt-4 max-w-2xl text-lg">
            From routine maintenance to complex installations, our licensed electricians handle it all with precision and care.
          </p>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={service.title}
                className={`bento-item card-lift p-6 ${service.span} ${
                  service.featured ? 'relative overflow-hidden min-h-[280px]' : 'min-h-[200px]'
                }`}
                data-testid={`service-card-${index}`}
              >
                {service.featured && service.image && (
                  <div className="absolute inset-0">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover opacity-20"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-zinc-900 via-zinc-900/80 to-transparent" />
                  </div>
                )}
                <div className="relative h-full flex flex-col">
                  <div className="w-12 h-12 bg-yellow-400/10 border border-yellow-400/20 flex items-center justify-center mb-4">
                    <Icon className="w-6 h-6 text-yellow-400" aria-hidden="true" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">{service.title}</h3>
                  <p className="text-zinc-400 flex-grow">{service.description}</p>
                  <a
                    href="#contact"
                    className="inline-flex items-center gap-2 text-yellow-400 mt-4 text-sm font-medium group"
                    data-testid={`service-link-${index}`}
                  >
                    Get a Quote
                    <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" aria-hidden="true" />
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesBento;
